import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'
import { userWebsitePaths } from '@/constants/userWebsitePaths';
export default function VerificationPending(props: any) {
    const { timeline, common } = useLocalTranslation();
    const customerCarePath = process.env.REACT_APP_USER_PANEL_URL + userWebsitePaths.customerCare;

    return (
        <div className='commonMainCon'>
            <p className='commonp1 mb-[8px] text-[#FD3535] font-bold'>{timeline.certificateSection.verificationPending.h1}</p>
            <p className='commonp1 mb-[15px]'>
                {timeline.certificateSection.verificationPending.p1}
                <a
                    className='ml-[5px] text-[#0173e7] underline'
                    href={customerCarePath}
                    target="_blank"
                    rel="noopener noreferrer">{common.statusText.contactSupport}</a>

            </p>
            <button
                disabled
                className='commonb1 commonb1_bg_grey cursor-not-allowed'>
                {common.statusText.claimYourCertificate}
            </button>
        </div>
    );
};


